import { useLocation, useNavigate } from "react-router-dom";
import { Avatar, AvatarBadge, AvatarGroup } from '@chakra-ui/react';
import { useDispatch, useSelector } from "react-redux";

import { perexodChatMenu } from "../../../../redux/reducer/perexodChatMenu/actiom/action";
import "./chatItemPrivateLight.css";
import "./chatItemPrivateDark.css";
import { useEffect, useState } from "react";
import axios from "axios";
import sockets from "../../../../socket/socket";
const socket = sockets;

export default function ChatItemPrivate({ item, thisClass, getChatItem = { getChatItem } }) {
    const getDarkModoe = useSelector(darkModes => darkModes);
    // const getMessageItems = useSelector(messageItem => messageItem);
    const onlineUSers = useSelector(onlineUSers => onlineUSers);
    const [countMessage, setcountMessage] = useState(0);
    const [data, setData] = useState({})
    const [chooseWokers, setChooseWokers] = useState([]);
    const gerChekcedCompany = useSelector((allWorkers) => allWorkers);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    // const perexeodMenu = useSelector(perexeodMenu => perexeodMenu).PerexodeChatMenuReducer.chekced;
    let getmyinfo = useSelector(compID => compID.getMayInfoReducer);
    const location = useLocation();
    const checkedChatItem = () => {
        navigate(`?chatID=${item._id}`)
        dispatch(perexodChatMenu("checkedChatItem"));
        getChatItem(item)
        axios.post('/whoReadThisMessageAdd/api', {
            data: item
            
        })
            .then(function (response) {
                console.log(response);
                axiosGetWorkers("/getCurrendCompanyWorkers/api");
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    function formatTime(isoString) {
        const date = new Date(isoString);
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
        return `${formattedHours}:${formattedMinutes} ${ampm}`;
    }
    useEffect(() => {
        if (Object.getOwnPropertyNames(item).length !== 0) {
            axios({
                method: 'get',
                url: '/whoReadThisMessageAdd/api',
                params: {
                    data: item
                }
            })
                .then(function (response) {
                    // Handle response data here

                    setcountMessage(response.data.data)

                })
                .catch(function (error) {
                    // Handle errors here
                });
        }

    }, [location.pathname]);

    useEffect(() => {
    
        function getLastMessage() {
            axios({
                method: 'get',
                url: '/getlastMessage/api',
                params: {
                    data: item
                }
            })
                .then(function (response) {
                    // Handle response data here
                    setData(response.data.data)
    
                })
                .catch(function (error) {
                    // Handle errors here
                });
          }
          getLastMessage()
          socket.on('updateCreatMessage', getLastMessage);
          return () => {
            socket.off('updateCreatMessage', getLastMessage);
            
          };
}, [])


useEffect(()=>{

    const getChatCounter=()=>{
        if (Object.getOwnPropertyNames(item).length !== 0) {
            axios({
                method: 'get',
                url: '/whoReadThisMessageAdd/api',
                params: {
                    data: item
                }
            })
                .then(function (response) {
                    // Handle response data here

                    setcountMessage(response.data.data)

                })
                .catch(function (error) {
                    // Handle errors here
                });
        }
    }
    getChatCounter()
    socket.on('updateCreatMessage', getChatCounter);
    return () => {
      socket.off('updateCreatMessage', getChatCounter);
      
    };

},[])

function axiosGetWorkers(url) {
    axios
      .get(url)
      .then(function (response) {
        // handle success
        setChooseWokers([]);
        if (response.data.data) {
          const newChooseWokers = response.data.data.map(item => item.workerID);
          setChooseWokers(prevWorkers => [...prevWorkers, ...newChooseWokers]);
          const adminWorkerID = gerChekcedCompany?.rootReducer?.users?.adminInfo?.workerID;
          if (adminWorkerID) {
            setChooseWokers(prevWorkers => [...prevWorkers, adminWorkerID]);
          }

          if (newChooseWokers.length > 0 || adminWorkerID) {
            socket.emit("updateCreatMessage", [...newChooseWokers, adminWorkerID]);
          } else {
            alert("No workers found");
          }
        }
      })
      .catch(function (error) {
        // handle error
        console.error("Error fetching data:", error);
      });
  }

    return (
        <div className={getDarkModoe.ToggleDarkModeReducer.chekced ? `chatItemPrivateDark ${thisClass}dark` : `chatItemPrivateLight ${thisClass}light`} onClick={checkedChatItem}>
            <div className="imgCon">

                {
                    onlineUSers.AllOnlineUsersReducer.allOnlineUsers.includes(item.chatOptions.userInfo._id) ?
                        <Avatar size={"md"} src={item.chatOptions.userInfo.img ? `/${item.chatOptions.userInfo.img}` : 'https://bit.ly/broken-link'}>
                            <AvatarBadge boxSize='1em' bg='green.500' />
                        </Avatar>
                        :
                        <Avatar size={"md"} src={item.chatOptions.userInfo.img ? `/${item.chatOptions.userInfo.img}` : 'https://bit.ly/broken-link'} />
                }

            </div>
            <div className="frame19">
                <div className="frame205">
                    {/* {
                        item.chatOptions.chatHidden && (
                            <div className="hicon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M5.00002 6.125C4.24062 6.125 3.62502 6.74061 3.62502 7.5C3.62502 8.25939 4.24062 8.875 5.00002 8.875C5.75941 8.875 6.37502 8.25939 6.37502 7.5C6.37502 6.74061 5.75941 6.125 5.00002 6.125ZM4.37502 7.5C4.37502 7.15482 4.65484 6.875 5.00002 6.875C5.34519 6.875 5.62502 7.15482 5.62502 7.5C5.62502 7.84518 5.34519 8.125 5.00002 8.125C4.65484 8.125 4.37502 7.84518 4.37502 7.5Z" fill="#858C99" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M5.00002 0.625C3.4122 0.625 2.12502 1.91218 2.12502 3.5V3.7614L2.11159 3.76571C1.23633 4.0501 0.550118 4.73632 0.265729 5.61158C0.124792 6.04534 0.124874 6.56594 0.125008 7.41908V7.58092C0.124874 8.43406 0.124792 8.95466 0.265729 9.38842C0.550118 10.2637 1.23633 10.9499 2.11159 11.2343C2.54535 11.3752 3.06595 11.3751 3.91909 11.375H6.08095C6.93408 11.3751 7.45468 11.3752 7.88844 11.2343C8.7637 10.9499 9.44991 10.2637 9.7343 9.38842C9.87524 8.95467 9.87516 8.43406 9.87502 7.58093V7.41907C9.87516 6.56594 9.87524 6.04533 9.7343 5.61158C9.44991 4.73632 8.7637 4.0501 7.88844 3.76571L7.87502 3.7614V3.5C7.87502 1.91218 6.58784 0.625 5.00002 0.625ZM3.95803 3.625C3.51843 3.62498 3.16757 3.62497 2.87502 3.64153V3.5C2.87502 2.3264 3.82641 1.375 5.00002 1.375C6.17362 1.375 7.12502 2.3264 7.12502 3.5V3.64153C6.83246 3.62497 6.48161 3.62498 6.04201 3.625H3.95803ZM2.56231 4.42665C2.86111 4.37631 3.26409 4.375 4.00002 4.375H6.00002C6.73594 4.375 7.13892 4.37631 7.43772 4.42665C7.52034 4.44057 7.59159 4.45786 7.65668 4.47901C8.30361 4.68921 8.81081 5.19641 9.02101 5.84334C9.12039 6.14919 9.12502 6.54017 9.12502 7.5C9.12502 8.45983 9.12039 8.85081 9.02101 9.15666C8.81081 9.80359 8.30361 10.3108 7.65668 10.521C7.35082 10.6204 6.95985 10.625 6.00002 10.625H4.00002C3.04019 10.625 2.64921 10.6204 2.34336 10.521C1.69642 10.3108 1.18922 9.80359 0.979021 9.15666C0.879643 8.85081 0.875017 8.45983 0.875017 7.5C0.875017 6.54017 0.879643 6.14919 0.979021 5.84334C1.18922 5.19641 1.69642 4.68921 2.34336 4.47901C2.40844 4.45786 2.47969 4.44057 2.56231 4.42665Z" fill="#858C99" />
                                </svg>
                            </div>
                        )
                    } */}

                    {
                        getmyinfo.myinfo.settings?.pinChatsID.includes(item._id) ?
                            <div className="pinChat">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.95588 2.15695C2.71323 2.13447 1.49603 2.71182 0.734506 3.77452C0.623524 3.9294 0.513542 4.1199 0.323234 4.44955L0.309689 4.47301C0.307692 4.47647 0.305684 4.47994 0.30367 4.48342C0.280902 4.52279 0.257264 4.56366 0.239205 4.60352C0.0669247 4.98375 0.187228 5.43273 0.526543 5.67588C0.562112 5.70136 0.603019 5.72494 0.64242 5.74765C0.645906 5.74966 0.64938 5.75166 0.652838 5.75366L3.73805 7.53491L1.92555 10.6743C1.822 10.8536 1.88345 11.083 2.06281 11.1865C2.24217 11.2901 2.47152 11.2286 2.57507 11.0493L4.38757 7.90991L7.47279 9.69116C7.47625 9.69316 7.47973 9.69517 7.48321 9.69718C7.52257 9.71995 7.56344 9.74358 7.6033 9.76164C7.98353 9.93392 8.43251 9.81362 8.67565 9.4743C8.70115 9.43873 8.72473 9.39781 8.74744 9.3584C8.74945 9.35492 8.75144 9.35146 8.75344 9.34801L8.76698 9.32455C8.95731 8.99492 9.0673 8.80441 9.14594 8.63086C9.68561 7.43976 9.57685 6.09666 8.93571 5.03162L8.98978 4.93798C9.78368 3.56289 9.31254 1.80457 7.93745 1.01066C6.56236 0.216748 4.80404 0.687888 4.01013 2.06298L3.95588 2.15695ZM4.77447 2.25991C5.01458 2.31669 5.25201 2.39712 5.48353 2.50203C5.65708 2.58066 5.84758 2.69065 6.17722 2.88098L7.19842 3.47058C7.52806 3.66088 7.71856 3.77086 7.87344 3.88184C8.07984 4.02975 8.26805 4.19496 8.43715 4.37431C8.88215 3.39092 8.51691 2.21123 7.56245 1.66018C6.60793 1.10908 5.40358 1.38269 4.77447 2.25991ZM4.13611 2.91638C3.06741 2.83024 1.99756 3.29954 1.34414 4.21138C1.25742 4.33239 1.16682 4.48842 0.959208 4.84801C0.944063 4.87424 0.935059 4.88986 0.928456 4.90176C0.924256 4.90934 0.922142 4.91352 0.922142 4.91352C0.897912 4.96758 0.91497 5.03124 0.962987 5.06594C0.962987 5.06594 0.966909 5.06851 0.974328 5.07296C0.985998 5.07997 1.00161 5.08899 1.02784 5.10414L4.43781 7.07289L7.84779 9.04164C7.87402 9.05678 7.88964 9.06579 7.90155 9.07239C7.90863 9.07632 7.91204 9.07807 7.91311 9.07861C7.96743 9.10322 8.03128 9.08592 8.06602 9.03745C8.06477 9.03919 8.06609 9.03759 8.07274 9.02652C8.07975 9.01485 8.08877 8.99924 8.10392 8.97301C8.31153 8.61342 8.40134 8.45694 8.46279 8.32133C8.92654 7.2978 8.79681 6.13443 8.18521 5.25143C7.98581 4.96355 7.73509 4.70538 7.43658 4.49148C7.31557 4.40476 7.15954 4.31415 6.79995 4.10654L5.82567 3.54404C5.46608 3.33643 5.3096 3.24662 5.174 3.18517C4.83776 3.03283 4.48694 2.94465 4.13611 2.91638Z" fill="#858C99" />
                                    </svg>
                                </div>
                                <p>{item.chatOptions.userInfo.name}</p>
                            </div>
                            :
                            <p>{item.chatOptions.userInfo.name}</p>
                    }


                </div>
                {
                    data?.typeMessage &&
                    <p>{data?.messageText}</p>
                }

            </div>
            {
                data?.typeMessage == "message" &&
                <p className="messageTime">{formatTime(data?.createdAt)} </p>
            }
            {
                countMessage > 0 && <p className="CountMessage">{countMessage}</p>
            }


        </div>
    )
}